//import { version } from '../../maplibre-gl-js/package.json';
// import { prefixUrl } from '@mapbox/batfish/modules/prefix-url';

function url(ext, options) {
    //if (options && options.local && process.env.DEPLOY_ENV === 'local') {
    // return prefixUrl(`/dist/maplibre-gl.${ext}`);
    //} else {
    options = options || {};

    if (options.env === 'openlayer') {
        return `https://cdnjs.cloudflare.com/ajax/libs/openlayers/4.6.5/ol.${ext}`;
    } else if (options.env === 'leaflet') {
        return `https://unpkg.com/leaflet@1.7.1/dist/leaflet.${ext}`;
    } else if (options.env === 'mapbox') {
        return `https://api.mapbox.com/mapbox-gl-js/v2.4.0/mapbox-gl.${ext}`;
    } else if (options.env === 'google') {
        return `https://maps.googleapis.com/maps/api/js?key={Google_Map_API_KEY}`;
    } else {
        return `https://unpkg.com/maplibre-gl@1.15.2/dist/maplibre-gl.${ext}`;
    }
    //}
}

function js(options) {
    return url('js', options);
}

function css(options) {
    return url('css', options);
}

export default { js, css };
